var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.39c4.004 0 7.268 3.29 7.333 7.393a.685.685 0 0 1-.388.632A16.243 16.243 0 0 1 11 20.964c-2.428 0-4.785-.533-6.945-1.55l.02.008-.011-.003a.659.659 0 0 1-.076-.041l-.016-.012-.003-.002-.051-.036-.014-.011-.035-.036-.015-.012-.001-.004-.012-.01-.023-.031-.019-.022-.005-.008-.006-.008-.024-.042-.012-.015v-.006l-.009-.012-.017-.042-.01-.02-.003-.007-.005-.01L3.7 19l-.012-.036-.003-.014-.006-.034-.007-.042v-.006l-.002-.008a.697.697 0 0 1-.003-.088l.007-.217c.176-3.921 3.276-7.046 7.104-7.163L11 11.39zm0 1.366c-3.067 0-5.603 2.36-5.958 5.415l-.02.186.394.166a14.953 14.953 0 0 0 5.139 1.068l.446.006c1.91.004 3.802-.36 5.577-1.072l.399-.167-.019-.187c-.347-2.986-2.777-5.307-5.75-5.411L11 12.756zm0-10.923c2.21 0 4 1.836 4 4.1 0 2.264-1.79 4.099-4 4.099s-4-1.835-4-4.1c0-2.263 1.79-4.099 4-4.099zM11 3.2c-1.473 0-2.667 1.223-2.667 2.733 0 1.509 1.194 2.733 2.667 2.733 1.473 0 2.667-1.224 2.667-2.733l-.005-.16C13.582 4.337 12.42 3.2 11 3.2z",
    fill: "#821BB8",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.1f3800f49cf8eec290327501b254c07a.svg";
export { ForwardRef as ReactComponent };